export default "__VITE_ASSET__DDeTEiFH__"